<template>
  <AwlTable :heading="tableHeadings" :rows="tableRows" striped>
    <template #column-key-status="{ value }">
      <template v-if="value === 'budgeted'">Previsto</template>
      <template v-else-if="value === 'accepted'">Accettato</template>
      <template v-else-if="value === 'started'">Avviato</template>
      <template v-else-if="value === 'completed'">Concluso</template>
    </template>

    <template #column-key-begin="{ row }">
      {{ row.begin }} - {{ row.end}}
    </template>
    <template #column-key-costi="{ value }">
      {{ value | money }}
    </template>
    <template #column-key-costiStruttura="{ value }">
      {{ value | money }}
    </template>
    <template #column-key-ricavo="{ value }">
      {{ value | money }}
    </template>
    <template #column-key-m1="{ value }">
      {{ value | money }}
    </template>
    <template #column-key-m1f="{ value }">
      {{ value | money }}
    </template>
    <template #column-key-m2="{ value }">
      {{ value | money }}
    </template>
    <template #column-key-m2f="{ value }">
      {{ value | money }}
    </template>
    <template #column-key-vat="{ value }">
      {{ value }}%
    </template>

    <template v-if="editEnabled" #actions-content="{ row }">
      <ActionShow class="mr-0 mr-md-2" :to="{ name: 'operative-company.projects.show', params: { projectId: row.id } }" />
      <ActionEdit class="mr-0 mr-md-2" :to="{ name: 'operative-company.projects.edit', params: { projectId: row.id } }" />
      <ActionDelete @click="remove(row.id)" />
    </template>
  </AwlTable>
</template>

<script>

import formatMoneyFilter from '@/filters/formatMoney';

export default {
  name: 'templates-list-table',
  components: {
    AwlTable: () => import('@/libs/Table/components/AwlTable'),
    ActionShow: () => import('@/libs/Table/components/Actions/ActionShow'),
    ActionDelete: () => import('@/views/components/Actions/ActionDelete'),
    ActionEdit: () => import('@/views/components/Actions/ActionEdit'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    templates: {
      type: Array,
      default: () => [],
    },
    editEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableHeadings () {
      return [
        { key: 'begin', label: 'Durata' },
        { key: 'name', label: 'Nome' },
        { key: 'status', label: 'Stato' },
        { key: 'vat', label: 'Iva' },
        { key: 'ricavo', label: 'Ricavo' },
        { key: 'costi', label: 'Costo totale' },
        { key: 'm1', label: 'Margine lordo' },
        { key: 'costiStruttura', label: 'Costi di struttura (QP)' },
        { key: 'm2', label: 'Margine secondo' },
        { key: 'costiFigurati', label: 'Costi figurati' },
        { key: 'm1f', label: 'Margine lordo (CF)' },
        { key: 'm2f', label: 'Margine secondo (CF)' },
      ];
    },
    tableRows () {
      return (this.templates || []).map(r => {
        r.margine = (parseInt(r.ricavo || 0) || 0) - (parseInt(r.totalCosts || 0) || 0);

        return r;
      });
    },
  },
  methods: {
    remove (id) {
      if (!this.editEnabled) {
        return;
      }

      this.$emit('delete', id);
    },
  },
};

</script>
